import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import SearchBox from "../../common/components/SearchBox";
import { useTheme } from "@mui/material/styles";
import {
  Typography,
  Box,
  Autocomplete,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";

import {
  getRequisitions,
  deleteRequisition,
} from "../../../store/recruitment/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import UpdateRequisitionDialog from "../components/UpdateRequisitionDialog";
import RequisitionDetailsDialog from "../components/RequisitionDetailsDialog";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import TableSkeleton from "../../common/components/TableSkeleton";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BackdropLoader from "../../common/components/BackdropLoader";
import axios from "axios";
import moment from "moment";

const ITEM_HEIGHT = 60;

const Requisition = (props) => {
  const { user, loading, requisitions, getRequisitions, deleteRequisition } =
    props;
  const theme = useTheme();
  const defaultIds = "";
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10
  );
  const [totalRequests, setTotalRequests] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);

  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [confirmRemoveRequisition, setConfirmRemoveRequisition] =
    useState(false);
  const [showEditRequisitionForm, setShowEditRequisitionForm] = useState(false);
  const [showRequisitionDetails, setShowRequisitionDetails] = useState(false);
  const [filterStatus, setFilterStatus] = useState({
    id: "",
    name: "All",
  });

  useEffect(() => {
    getActiveRequisitionStatuses();

    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
      currentStatus: filterStatus?.id || defaultIds,
    };

    getRequisitions(query, setTotalRequests, setIsLoading);
  }, []);

  const onSearch = () => {
    if (!searchTerm) return false;
    const query = {
      searchTerm: searchTerm,
      page: 1,
      size: itemPerPage,
      currentStatus: filterStatus?.id || defaultIds,
    };
    getRequisitions(query, setTotalRequests, setIsLoading);
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);
    const query = {
      searchTerm: searchTerm,
      currentStatus: filterStatus?.id || defaultIds,
      page: currentPage,
      size: itemPerPage,
    };
    getRequisitions(query, setTotalRequests, setIsLoading1);
  };

  const getNo = (idToSearch) => {
    return requisitions.findIndex(({ id }) => id === idToSearch);
  };

  const [requisitionStatuses, setRequisitionStatuses] = useState([
    {
      id: "",
      name: "All",
    },
  ]);

  const getActiveRequisitionStatuses = async () => {
    try {
      const { data } = await axios.get(
        "/api/recruitment/active-requisition-statuses"
      );

      setRequisitionStatuses([
        {
          id: "",
          name: "All",
        },
        ...data,
      ]);
    } catch (error) {}
  };

  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        <div className="w-100">
          <AppBar
            position="static"
            elevation={0}
            style={{ overflow: "hidden" }}
            className="app-bar w-100"
          >
            <Toolbar className="row">
              <div className="col-lg-6">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  className="text-uppercase d-inline-flex align-items-center"
                >
                  <span>RECRUITMENT </span>
                  <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                    <span
                      className="material-icons  text-dark"
                      style={{ position: "relative", top: "4px" }}
                    >
                      chevron_right
                    </span>
                  </span>

                  <small style={{ color: "rgb(7, 142, 206)" }}>
                    {filterStatus && filterStatus.name} requisitions (
                    {totalRequests})
                  </small>
                </Typography>
              </div>

              <div className="col-lg-6">
                <div className="d-flex justify-content-right  align-items-right">
                  <Autocomplete
                    sx={{ width: 300 }}
                    className="mr-2"
                    size="small"
                    id="filterStatus"
                    defaultValue={null}
                    value={filterStatus || null}
                    options={requisitionStatuses}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(event, currentStatus) => {
                      const query = {
                        searchTerm: "",
                        currentStatus: currentStatus?.id || defaultIds,
                        page: currentPage,
                        size: itemPerPage,
                      };
                      setFilterStatus(currentStatus);
                      getRequisitions(query, setTotalRequests, setIsLoading1);
                    }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, filterStatus) => (
                      <Box component="li" {...props} key={filterStatus.id}>
                        {filterStatus.name}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        style={{
                          width: "100%",
                          height: "35px!important",
                          position: "relative",
                          borderRadius: "8px",
                          padding: "1px!important",
                        }}
                        {...params}
                        label="Filter By"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "filterStatus", // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />

                  <SearchBox
                    onSearch={(search) => {
                      setSearchTerm(search);

                      if (!search) {
                        const currentPage = 1;
                        setCurrentPage(currentPage);
                        const query = {
                          searchTerm: "",
                          page: currentPage,
                          currentStatus: filterStatus?.id || defaultIds,
                          size: itemPerPage,
                        };
                        getRequisitions(query, setTotalRequests, setIsLoading1);
                      }
                    }}
                    placeholder="Search…"
                  />
                  <Button
                    disabled={!searchTerm}
                    onClick={() => onSearch()}
                    variant="contained"
                    size="small"
                    disableElevation
                    className="mr-2 "
                    style={{
                      borderRadius: "8px",
                      height: "38px",
                      border: `1px solid rgb(7, 142, 206)`,
                      color: "#fff",
                      alignItems: "center",
                      fontSize: ".75rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textTransform: "initial",
                      backgroundColor: "rgb(7, 142, 206)",
                      marginLeft: "5px",
                      "&:hover": {
                        backgroundColor: "#f0f2f5",
                      },
                    }}
                  >
                    <span className="material-icons">search</span>GO
                  </Button>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          <div
            className="mx-3"
            style={{
              // padding: theme.spacing(0.4),
              height: "auto",
              maxHeight: "auto",
              // margin: "1.2em",
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              overflow: "visible",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            }}
          >
            <CardContent>
              <div
                style={{
                  overflow: "auto",
                  height: "65vh",
                }}
              >
                <table className="table table-striped table-hover  fixTableHead">
                  <thead>
                    <tr style={{ backgroundColor: "#f0f2f5" }}>
                      <th scope="col">#</th>
                      <th scope="col" className="text-left py-2">
                        RequisitionId
                      </th>
                      <th scope="col" className="text-left py-2">
                        PostionTitle
                      </th>
                      <th scope="col" className="text-left">
                        Unit
                      </th>

                      <th scope="col" className="text-left">
                        EmploymentGroup
                      </th>
                      <th scope="col" className="text-left">
                        RecruitmentMode
                      </th>
                      <th scope="col" className="text-left">
                        Exams
                      </th>
                      <th scope="col" className="text-right">
                        Level
                      </th>
                      <th scope="col" className="text-center">
                        IV
                      </th>

                      <th scope="col" className="text-center">
                        NumberOfPosts
                      </th>

                      <th scope="col" className="text-left">
                        RequestedOn
                      </th>

                      <th scope="col" className="text-right">
                        Status
                      </th>
                      <th scope="col" className="text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <TableSkeleton cols={13} />
                  ) : (
                    <tbody>
                      <BackdropLoader isLoading={isLoading1} />
                      {requisitions.map((requisition, index) => (
                        <RequisitionCard
                          key={requisition.id}
                          requisition={requisition}
                          index={getNo(requisition.id)}
                          deleteRequisition={deleteRequisition}
                        />
                      ))}
                    </tbody>
                  )}
                </table>

                <NoRecordMessage
                  isEmpty={!requisitions.length && !isLoading}
                  title={"No record found"}
                />
              </div>

              {!isLoading && (
                <div
                  className="d-flex justify-content-center  align-items-center"
                  style={{ overflow: "hidden" }}
                >
                  <div className="mt-3">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel={
                        <>
                          <span className="pr-1 d-none d-md-inline">Next</span>
                          <i className="fas fa-angle-double-right"></i>
                        </>
                      }
                      previousLabel={
                        <>
                          <i className="fas fa-angle-double-left"></i>
                          <span className="pl-1  d-none d-md-inline">
                            Previous
                          </span>
                        </>
                      }
                      pageRangeDisplayed={3}
                      // marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      pageCount={Math.ceil(totalRequests / itemPerPage)}
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                      previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                      nextLinkClassName="btn btn-outline-info btn-sm ml-1"
                      activeLinkClassName="active"
                    />
                  </div>

                  {!!requisitions.length && (
                    <select
                      className="custom-select custom-select-sm ml-2"
                      style={{ width: "100px" }}
                      value={itemPerPage}
                      onChange={(event) => {
                        const itemPerPage = +event.target.value;
                        window.localStorage.setItem(
                          "ITEM_PER_PAGE",
                          itemPerPage
                        );
                        setItemPerPage(itemPerPage);
                        const query = {
                          searchTerm: searchTerm,
                          page: currentPage,
                          size: itemPerPage,
                          currentStatus: filterStatus?.id || defaultIds,
                        };
                        getRequisitions(query, setTotalRequests, setIsLoading);
                      }}
                    >
                      {[10, 50, 100].map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                  )}
                </div>
              )}
            </CardContent>
          </div>
        </div>
      </Box>
    </>
  );
};

const mapStateToProps = ({ user, loading, requisitions }) => {
  return { user, loading, requisitions };
};
export default connect(mapStateToProps, {
  getRequisitions,
  deleteRequisition,
})(Requisition);

const RequisitionCard = (props) => {
  const { requisition, index, deleteRequisition } = props;
  const { hasPermissions } = useRequiredAuth();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showRequisitionDetails, setShowRequisitionDetails] = useState(false);
  const [confirmRemoveRequisition, setConfirmRemoveRequisition] =
    useState(false);

  return (
    <>
      <tr>
        <th scope="row" style={{ backgroundColor: "#f0f2f5" }}>
          {index + 1}
        </th>
        <td className="text-left"> {requisition.id}</td>
        <td className="text-left"> {requisition.positionName}</td>
        <td className="text-left"> {requisition.unitName}</td>

        <td className="text-left">{requisition.employeeGroupName}</td>

        <td className="text-left">
          {requisition.isInternal ? "Internal recruitment" : "Open competition"}
        </td>
        <td className="text-left">
          {requisition.willHavePsychometricTest && (
            <>
              <span>1:PsychometricTest</span>
              <br />
            </>
          )}

          {requisition.willHaveWrittenExam && (
            <>
              <span>
                {requisition.willHavePsychometricTest ? "2" : "1"}:Written
              </span>
              <br />
            </>
          )}

          {requisition.willHaveOralExam && (
            <span>
              {requisition.willHavePsychometricTest &&
              requisition.willHaveWrittenExam
                ? "3"
                : requisition.willHaveWrittenExam
                ? "2"
                : "1"}
              :Oral
            </span>
          )}
        </td>
        <td className="text-right">
          {requisition.levelName}.{requisition.scaleName}
        </td>
        <td className="text-center">{requisition.indexValue}</td>
        {/* <td className="text-left">{requisition.hiringModeName}</td> */}

        <td className="text-center">{requisition.numberOfPosts}</td>

        <td className="text-center">
          {moment(requisition.createdOn).format("DD/MM/YYYY")}
        </td>
        <td className="text-right">
          <span
            className={`text-${
              requisition.statusId === 2
                ? "danger"
                : requisition.statusId === 0
                ? "dark"
                : "success"
            }`}
          >
            {requisition.statusName}
          </span>
        </td>

        <td className="text-center">
          <IconButton
            size="small"
            onClick={handleOpenMenu}
            aria-label="settings"
          >
            <Badge color="info">
              <span className="material-icons">more_vert</span>
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "auto",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                // maxHeight: ITEM_HEIGHT * 4.5,
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <span>
              <MenuItem
                onClick={() => {
                  handleCloseMenu();
                  setShowRequisitionDetails(true);
                }}
                className="text-dark font-weight-bold text-primary"
              >
                <OpenInNewIcon className="mr-2 text-primary" /> Preview
              </MenuItem>
              {requisition.statusId === 0 && <Divider className="my-1" />}
            </span>

            {hasPermissions(["IS_HR", "IS_CBM"]) &&
              requisition.statusId === 0 && (
                <span>
                  <MenuItem
                    onClick={() => {
                      handleCloseMenu();
                      setConfirmRemoveRequisition(true);
                    }}
                    className="text-danger font-weight-light"
                  >
                    <DeleteForeverIcon className="mr-2 text-danger" /> Delete
                  </MenuItem>
                </span>
              )}
          </Menu>
        </td>
      </tr>

      {showRequisitionDetails && (
        <RequisitionDetailsDialog
          showRequisitionDetails={showRequisitionDetails}
          setShowRequisitionDetails={setShowRequisitionDetails}
          selectedRequisition={requisition}
        />
      )}

      {confirmRemoveRequisition && (
        <ConfirmationDialog
          confirmationDialog={confirmRemoveRequisition}
          message={`Are you sure you want to delete this requisition?`}
          setConfirmationDialog={setConfirmRemoveRequisition}
          onYes={() => {
            deleteRequisition(requisition, setConfirmRemoveRequisition);
          }}
        />
      )}
    </>
  );
};
